import * as index_php from './index.php'

export default [index_php]
